/* eslint-disable no-param-reassign */

export default {
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setBoardConfigs(state, payload) {
    state.allConfigs = payload;
  },
  setBoardConfig(state, payload) {
    state.allConfigs[state.projectId] = payload;
  },

  setProjectId(state, payload) {
    state.projectId = payload;
  },
  setAllFields(state, payload) {
    state.allFields = payload;
  },
  setCustomSort(state, payload) {
    state.customSort = payload;
  },
  setContextMenu(state, payload) {
    const {
      item, type, menu, position, side,
    } = payload;
    const index = state.contextMenus.findIndex(contextItem => contextItem.item.id === item.id && contextItem.type === type && contextItem.menu === menu);
    const newList = [...state.contextMenus];

    if (index === -1) {
      newList.push({
        item, type, menu, position, side,
      });
    } else {
      newList.splice(index, 1);
    }

    state.contextMenus = newList;
  },
  setNameEditKey(state, payload) {
    state.nameEditTaskKey = payload;
  },
  setTaskCardEditing(state, payload) {
    state.taskCardEditing = payload;
  },
  setTaskSettingsInfo(state, payload) {
    state.taskSettingsInfo = payload;
  },
  addNewTaskToPool(state, payload) {
    const newList = [...state.newTasksPool];

    newList.push(payload);

    state.newTasksPool = newList;
  },
  removeNewTaskFromPool(state, payload) {
    const taskIndex = state.newTasksPool.indexOf(payload);
    const newList = [...state.newTasksPool];

    if (taskIndex > -1) {
      newList.splice(taskIndex, 1);
    }

    state.newTasksPool = newList;
  },
  clearNewTasksPool(state) {
    state.newTasksPool = [];
  },
  setDatesWidth(state, payload) {
    state.datesWidth = payload;
  },
  clearContextMenus(state) {
    state.contextMenus = [];
  },
  resetState(state) {
    // state.isLoading = false;
    state.allConfigs = {};
    state.projectId = null;
    state.highlightOverdue = false;
    state.allFields = [];
    state.contextMenus = [];
    state.nameEditTaskKey = null;
    state.taskCardEditing = null;
    state.taskSettingsInfo = null;
    state.newTasksPool = [];
  },
};
